import { PROGRAM_DAY_KEYS } from "./programState";

const normalizeProgramStateForComparison = (programState) => ({
  ...programState,
  notes: (programState.notes || "")
    .split("\n")
    .filter((line) => line && line.trim() !== "")
    .join("\n"),
  days: PROGRAM_DAY_KEYS.reduce((days, dayKey) => {
    const day = programState.days[dayKey];

    return {
      ...days,
      [dayKey]: {
        ...day,
        label: day.label && day.label.trim() !== "" ? day.label : "",
      },
    };
  }, {}),
});

export const areProgramStatesEqual = (firstProgramState, secondProgramState) =>
  JSON.stringify(normalizeProgramStateForComparison(firstProgramState)) ===
  JSON.stringify(normalizeProgramStateForComparison(secondProgramState));

export const isProgramStateValid = (programState) =>
  programState.title?.trim().length > 0 && programState.clientName?.trim().length > 0;
